
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IOrderForm } from '@/types/placeOrderTypes';
@Component({})
export default class OrderCheckMessage extends Vue {
  @Prop({}) form!: IOrderForm;
}
